import { HandleDetail } from '../../common/handleDetail'
import { HIGH_LIGHT_TITLE } from '../constants'

export const getKeyByTypePrefix = (typePrefix) => {
  const lastIndexSlash = typePrefix.lastIndexOf('/')
  return typePrefix.slice(lastIndexSlash + 1)
}

export const handleHighLight = (payload) => {
  const keys = Object.keys(HIGH_LIGHT_TITLE)

  return keys.map((key, index, arr) => {
    return {
      title: `portfolio.segment.${HIGH_LIGHT_TITLE[key]}`,
      detail: renderDetail(payload, key),
      isShowSeparator: index !== arr.length - 1,
      isI18n: true,
      scrollElementClass: HIGH_LIGHT_TITLE[key],
    }
  })
}

const renderDetail = (payload, key) => {
  if (!payload[key]) return ''

  if (key === 'totalCompanies') {
    return (
      <HandleDetail
        path="PortfolioInsights/Details"
        otherParams={{ isHighlight: true, param: {} }}
      >
        {payload[key]}
      </HandleDetail>
    )
  }

  return payload[key]
}
